
import Vue from "vue";
import { Component } from "vue-property-decorator";
import DragPlaceholder from "./Canvas/DragPlaceholder.vue";
import RightClickMenu from "./Canvas/RightClickMenu.vue";

@Component({
  components: {
    DragPlaceholder,
    RightClickMenu
  }
})
export default class CanvasChrome extends Vue {}
